module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/search-315ea0c54b29ce990709501575e8e413.svg";